/** @format */

import { AfterContentChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Location, formatDate } from '@angular/common';
import { Observable, Subject, takeUntil } from 'rxjs';
import { NgbModal, NgbActiveModal, NgbModalOptions, NgbModalRef, NgbOffcanvas, NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import {
	getEmployeeTimesheets,
	getExceptionTypes,
	getPayPeriodEntries,
	getProfile,
	getSelectedYear,
	getTimesheets,
	getTimesheetHistory,
	getUserImages,
	getPayPeriods,
} from 'src/app/store';
import {
	BankOrPayoutOptionsCode,
	CalendarDayEntry,
	CalendarMonthlyTimesheets,
	Days,
	EditTimesheetFormChanges,
	ExceptionType,
	FilterToggleStates,
	OtherLeaveOptions,
	OverTimeContextOptions,
	SaveSubmitTimesheet,
	SaveTimesheet,
	SickTypeOptions,
	SubmitTimesheet,
	Timesheet,
	TimesheetEntry2,
	TimesheetEntryType,
	TimesheetExceptionType,
	TimesheetMetaDataOption,
	BankedTypeOptions,
	UnionBusinessOptions,
	PostTimesheet,
	PayPeriodEntry,
	CDOBankingOptions,
	OverTimePrescheduledOptions,
	BankedCDOMetadata,
	TimesheetMetadata,
	ManagerEmployeeTimesheetView,
	GetTimesheetHistory,
	UpdateTimesheetApproval,
	TimesheetApprovalSubmission,
	TimesheetStatus,
	EmploymentStatus,
	UnionCode,
	GetAllTimesheets,
	ScheduledActingAssignment,
	GetProfile,
	PayPeriod,
	WorkOrderChargeAbleEntries,
} from 'src/app/store/application';

// import { TimeEntryTypes } from '../timesheet/TimeEntryOptions';
import { Profile, Configuration, blankConfiguration } from 'src/app/models/profile';
import { UntypedFormControl, UntypedFormGroup, Validators, NgForm, FormControl } from '@angular/forms';
import * as HelperFunctions from 'src/assets/helper-functions/helper-functions';
import { Clipboard } from '@angular/cdk/clipboard';
import { SafeUrl } from '@angular/platform-browser';

@Component({
	selector: 'app-timesheet',
	templateUrl: './timesheet.component.html',
	styleUrls: ['./timesheet.component.scss'],
	standalone: false,
})
export class TimesheetComponent implements OnInit, OnDestroy, AfterContentChecked {
	@ViewChild('bankCDODialog') content: any;
	@ViewChild('timesheetHistoryModal') timesheetHistoryModal: any;

	@Input() isEditingEmployeeTimesheet = false;
	@Input() public currentEmployeeEmail = '';
	@Input() public currentConfiguration: Configuration = blankConfiguration;
	@Input() public timeEntryTypes: TimesheetExceptionType[] = [];
	@Input() public selectedTimesheet: Timesheet | null = null;
	@Input() public weekOneTsHasUsedCdo: boolean = false;
	@Input() public canOnlySubmitTimesheet: boolean = false;
	@Output() approveEditedTimesheet = new EventEmitter<ManagerEmployeeTimesheetView>();

	employeeTimesheets$: Observable<ManagerEmployeeTimesheetView[]>;
	currentEmployeeTimesheets: ManagerEmployeeTimesheetView[] = [];

	exceptionTypes$!: Observable<ExceptionType[]>;
	exceptionTypes!: ExceptionType[];

	payPeriods$!: Observable<PayPeriod[]>;
	payPeriods!: PayPeriod[];

	payPeriodEntries$!: Observable<PayPeriodEntry[]>;
	payPeriodEntries!: PayPeriodEntry[];

	timesheets$: Observable<Timesheet[]>;
	timesheets: Timesheet[] = [];
	private ngUnsubscribe: Subject<void> = new Subject();

	timesheetHistory$: Observable<Timesheet[]>;
	timesheetHistory: Timesheet[] = [];

	userImages$: Observable<{ [id: string]: SafeUrl }>;
	userImages: { [id: string]: SafeUrl } = {};

	userScheduledActings: ScheduledActingAssignment[] = [];
	selectedWeekScheduledActing?: ScheduledActingAssignment;

	selectedYear$: Observable<number>;
	selectedYear: number = new Date().getFullYear();
	selectedPayPeriodDays: CalendarDayEntry[] = [];

	selectedPayPeriodTimesheets: Timesheet[] = [];

	profile$: Observable<Profile>;

	hasSubmittedTimesheet$: Subject<boolean> = new Subject();
	hasSubmittedTimesheet = false;
	profile!: Profile;

	employeeConfigurations: Configuration[] = [];

	addedRows: TimesheetEntry2[] = [];

	addRowForm!: UntypedFormGroup;

	bankCDOForm!: UntypedFormGroup;
	bankCDOModalRef!: NgbModalRef;
	bankCDOTextLimit = 30;
	timesheetHistoryModalRef!: NgbModalRef;

	readonly commentsMaxLength = 30;
	readonly workOrderDescLimit = 50;

	calendarOneMonth = 0;
	calendarTwoMonth = 0;
	calendarOneYear = 0;
	calendarTwoYear = 0;
	isCalendarOneSelected = false;
	hasCalendarHadInitialLoad = false;

	yearsDataProvided: number[] = [];
	allCalendarTimesheets: CalendarMonthlyTimesheets[] = [];
	payDates: Date[] = [];

	payperiodWeek: string = '';

	currentType = '';
	selectedBankType = '';

	natureOfWorkTextLimit = 30;

	optionDisplayLookup: { [id: string]: any } = {};
	showWhenOtStartRadio = true;

	editEmp = false;
	empNum: string | null | undefined;
	empName = '';

	dateFrRoute: Date | undefined;

	selectedHistoryTS = new Set();

	selectedCdoReassignmentDate: Date | null = null;
	toggleCdoDateSelectionPanel: boolean = false;
	cdoPayPeriodCalendarTimesheets!: CalendarMonthlyTimesheets;

	ngbStartDate: NgbDate = new NgbDate(2022, 1, 1);
	timesheetPayperiod!: PayPeriod;
	cdoReschedulingDate!: Date;

	compareNgSelectOptions = (a: TimesheetExceptionType, b: TimesheetExceptionType) => a?.code === b?.code;

	userIsSignedIn() {
		return this.profile.user.id !== -1;
	}

	userIsExemptManager() {
		return this.currentConfiguration?.unionCode === UnionCode.ExemptManagement;
	}

	isUserAuxiliary() {
		return this.currentConfiguration?.employmentStatus === EmploymentStatus.AUX;
	}

	applyOptionFilters() {
		if (!this.userIsSignedIn()) {
			return;
		}

		if (!this.currentConfiguration || this.currentConfiguration.id === -1) {
			return;
		}

		this.timeEntryTypes = HelperFunctions.filterTimeEntryTypes(this.currentConfiguration);
		this.overTimeStartDetails = this.filterOverTimeStartDetails();
		this.bankOrPayoutOptions = this.filterBankOrPayoutOptions();
		this.sickTypeOptions = this.filterSickTypeOptions();
		this.otherLeaveOptions = this.filterOtherLeaveOptions();
		this.bankedTypeOptions = this.filterBankedTypeOptions();
	}

	_overtimePrescheduledDetails: TimesheetMetaDataOption[] = [
		{ code: OverTimePrescheduledOptions.PrescheduledOTyes, active: true, entryText: 'Yes' },
		{ code: OverTimePrescheduledOptions.PrescheduledOTno, active: true, entryText: 'No' },
	];
	overtimePrescheduledDetails: TimesheetMetaDataOption[] = this._overtimePrescheduledDetails;
	filterOverTimePrescheduledDetails() {
		return this._overtimePrescheduledDetails.filter((o) => o.active);
	}

	_overTimeStartDetails: TimesheetMetaDataOption[] = [
		{ code: OverTimeContextOptions.ScheduleAdjacent, active: true, entryText: 'Adjacent to my regular shift' },
		{ code: OverTimeContextOptions.ScheduledNonAdjacent, active: true, entryText: 'Separate from my regular shift' },
	];
	overTimeStartDetails: TimesheetMetaDataOption[] = this._overTimeStartDetails;
	filterOverTimeStartDetails() {
		return this._overTimeStartDetails.filter((o) => o.active);
	}

	_bankOrPayoutOptions: TimesheetMetaDataOption[] = [
		{ code: BankOrPayoutOptionsCode.BankIt, active: true, entryText: 'Bank it' },
		{ code: BankOrPayoutOptionsCode.PayOut, active: true, entryText: 'Get paid on my next paycheck' },
	];
	bankOrPayoutOptions: TimesheetMetaDataOption[] = this._bankOrPayoutOptions;
	filterBankOrPayoutOptions() {
		return this._bankOrPayoutOptions
			.filter((o) => o.active)
			.filter((o) => !(o.code === BankOrPayoutOptionsCode.BankIt && this.isUserAuxiliary())); // Auxiliary staff can be paid OT but not bank it
	}

	_sickTypeOptions: TimesheetMetaDataOption[] = [
		{ code: SickTypeOptions.Personal, active: true, entryText: 'Personal' },
		{ code: SickTypeOptions.Family, active: true, entryText: 'Family' },
		{ code: SickTypeOptions.UnpaidSick, active: true, entryText: 'Unpaid' },
		{ code: SickTypeOptions.WCBSick, active: true, entryText: 'WCB' },
		{ code: SickTypeOptions.WCBUnpaid, active: true, entryText: 'WCB Unpaid' },
	];
	sickTypeOptions: TimesheetMetaDataOption[] = this._sickTypeOptions;
	filterSickTypeOptions() {
		return this._sickTypeOptions.filter((o) => o.active);
	}

	_otherLeaveOptions: TimesheetMetaDataOption[] = [
		{ code: OtherLeaveOptions.Compassionate, active: true, entryText: 'Compassionate' },
		{ code: OtherLeaveOptions.JuryDuty, active: true, entryText: 'Jury Duty' },
		{ code: OtherLeaveOptions.Maternity, active: true, entryText: 'Maternity (Unpaid)' },
		{ code: OtherLeaveOptions.Parental, active: true, entryText: 'Parental (Unpaid)' },
		{ code: OtherLeaveOptions.Unpaid, active: true, entryText: 'Unpaid' },
	];
	otherLeaveOptions: TimesheetMetaDataOption[] = this._otherLeaveOptions;
	filterOtherLeaveOptions() {
		return this._otherLeaveOptions.filter((o) => o.active);
	}

	_bankedTypeOptions: TimesheetMetaDataOption[] = [
		{ code: BankedTypeOptions.COT, active: false, entryText: 'Current Year OT Bank' },
		{ code: BankedTypeOptions.POT, active: false, entryText: 'Past Year OT Bank' },
		{ code: BankedTypeOptions.YOT, active: true, entryText: 'OT Bank' },
		{ code: BankedTypeOptions.COUNCIL_OT, active: true, entryText: 'Council OT Bank' },
		{ code: BankedTypeOptions.CDO, active: true, entryText: 'CDO Bank' },
		{ code: BankedTypeOptions.STAT_CDO, active: true, entryText: 'Stat Bank' },
	];
	bankedTypeOptions: TimesheetMetaDataOption[] = this._bankedTypeOptions;
	filterBankedTypeOptions() {
		return this._bankedTypeOptions
			.filter((o) => o.active)
			.filter((o) => !(o.code === BankedTypeOptions.COUNCIL_OT && !this.userIsExemptManager()));
	}

	_unionBusinessOptions: TimesheetMetaDataOption[] = [
		{ code: UnionBusinessOptions.UnionExp, active: true, entryText: 'At Union Expense' },
		{ code: UnionBusinessOptions.DistExp, active: true, entryText: 'At District Expense' },
	];
	unionBusinessOptions: TimesheetMetaDataOption[] = this._unionBusinessOptions;
	filterUnionBusinessOptions() {
		return this._unionBusinessOptions.filter((o) => o.active);
	}

	cdoBankOptions: TimesheetMetaDataOption[] = [
		{ code: CDOBankingOptions.NextWeek, active: true, entryText: "I'll take it next week" },
		{ code: CDOBankingOptions.PreviousWeek, active: true, entryText: 'I took it last week' },
		{ code: CDOBankingOptions.HolidayClosure, active: true, entryText: "I'll take it during the December office closure" },
		{ code: CDOBankingOptions.StatAdjustment, active: true, entryText: "I'll use it for the statutory holiday adjustments" },
		{ code: CDOBankingOptions.Other, active: true, entryText: 'Other (please specify):' },
	];

	workOrderChargeAbleEntries: WorkOrderChargeAbleEntries[] = [
		{ entryType: TimesheetEntryType.REGULAR_DAY, workOrderChargeable: true },
		{ entryType: TimesheetEntryType.ACTING, workOrderChargeable: true },
		{ entryType: TimesheetEntryType.OVERTIME, workOrderChargeable: true },
		{ entryType: TimesheetEntryType.COUNCIL, workOrderChargeable: true },
		{ entryType: TimesheetEntryType.SICK, workOrderChargeable: true },
		{ entryType: TimesheetEntryType.VACATION, workOrderChargeable: true },
		{ entryType: TimesheetEntryType.CDO, workOrderChargeable: false },
		{ entryType: TimesheetEntryType.BANKED, workOrderChargeable: false },
		{ entryType: TimesheetEntryType.TRAINING, workOrderChargeable: false },
		{ entryType: TimesheetEntryType.OTHER, workOrderChargeable: true },
		{ entryType: TimesheetEntryType.STAT, workOrderChargeable: true },
		{ entryType: TimesheetEntryType.UNION, workOrderChargeable: false },
		{ entryType: TimesheetEntryType.STANDBY, workOrderChargeable: false },
	];

	editTimesheetFormChanges!: EditTimesheetFormChanges;
	newEditFormChanges!: EditTimesheetFormChanges;

	@ViewChild('formDir', { static: true }) sidebarForm: NgForm = new NgForm([], []);

	filterToggleStates: FilterToggleStates = {
		payPeriod: true,
		payDay: false,
		statHoliday: false,
		holidayClosure: false,
		cdo: false,
		timesheets: true,
	};

	isEdit = false;
	toggleEdit = false;

	constructor(
		private store: Store<{}>,
		private changeDetector: ChangeDetectorRef,
		private offcanvasService: NgbOffcanvas,
		private modalService: NgbModal,
		public activeModal: NgbActiveModal,
		private route: ActivatedRoute,
		private location: Location,
	) {
		this.selectedYear$ = this.store.select(getSelectedYear);
		this.profile$ = this.store.select(getProfile);
		this.timesheets$ = this.store.select(getTimesheets);
		this.timesheetHistory$ = this.store.select(getTimesheetHistory);
		this.exceptionTypes$ = this.store.select(getExceptionTypes);
		this.payPeriodEntries$ = this.store.select(getPayPeriodEntries);
		this.payPeriods$ = this.store.select(getPayPeriods);
		this.employeeTimesheets$ = this.store.select(getEmployeeTimesheets);
		this.userImages$ = this.store.select(getUserImages);

		// this.timeEntryTypes = TimeEntryTypes;
		this.addRowForm = new UntypedFormGroup({
			type: new UntypedFormControl(null, Validators.required),
			comments: new UntypedFormControl(''),
			isWorkOrderTime: new UntypedFormControl(false),
		});

		this.addRowForm.get('type')?.valueChanges.subscribe((exceptionType: TimesheetExceptionType) => {
			if (exceptionType) {
				this.removeAddedFormControls();
				this.addRequiredFormControls(exceptionType.code);
				this.currentType = exceptionType.code;

				if (this.currentType === 'Training') {
					this.addRowForm.controls.comments.addValidators(Validators.required);
				} else {
					this.addRowForm.controls.comments.removeValidators(Validators.required);
				}
			}
		});

		this.bankCDOForm = new UntypedFormGroup({
			cdoUsageType: new UntypedFormControl('payPeriod', Validators.required),
			bankType: new UntypedFormControl(null, Validators.required),
		});

		this.bankCDOForm.get('bankType')?.valueChanges.subscribe((bankType: string) => {
			this.selectedBankType = bankType;

			if (bankType === 'Other') {
				this.bankCDOForm.addControl('otherTypeText', new UntypedFormControl('', Validators.required));
			} else {
				if (this.bankCDOForm.contains('otherTypeText')) {
					this.bankCDOForm.removeControl('otherTypeText');
				}
			}
		});

		this.addedRows = [];
		const currentMonth = new Date().getMonth();

		this.calendarOneYear = this.selectedYear;
		this.calendarTwoYear = this.selectedYear;

		if (currentMonth !== 11) {
			this.calendarOneMonth = currentMonth;
			this.calendarTwoMonth = currentMonth + 1;
			this.isCalendarOneSelected = true;
		} else {
			this.calendarOneMonth = currentMonth - 1;
			this.calendarTwoMonth = currentMonth;
			this.isCalendarOneSelected = false;
		}

		this.optionDisplayLookup = [
			this._overtimePrescheduledDetails,
			this._overTimeStartDetails,
			this._bankOrPayoutOptions,
			this._sickTypeOptions,
			this._otherLeaveOptions,
			this._bankedTypeOptions,
			this._unionBusinessOptions,
		].reduce((previousValue: { [id: string]: any }, currentValue: TimesheetMetaDataOption[]) => {
			currentValue.forEach((v) => (previousValue[v.code] = v.entryText));
			return previousValue;
		}, {});

		document.addEventListener('click', (event: any) => {
			if (event.target?.className === 'offcanvas-backdrop fade') {
				this.close();
			}
		});

		document.addEventListener('keydown', (event: any) => {
			if (event.key === 'Escape') {
				this.close();
			}
		});

		window.onresize = () => this.setContentCustomStyles.bind(this);
		this.setContentCustomStyles();
	}

	updateWorkOrderControls() {
		let comments = this.addRowForm.value.comments;
		if (this.addRowForm.value.isWorkOrderTime) {
			this.addRowForm.addControl('workOrderNumber', new FormControl('', [Validators.required, Validators.pattern(/^\\\d+\.$|^\d+$/)]));
			this.addRowForm.addControl('workOrderDesc', new UntypedFormControl(comments, Validators.required));

			if (this.addRowForm.value.type.code === TimesheetEntryType.OVERTIME) {
				this.addRowForm.removeControl('natureOfWorkOT');
			}
		} else {
			this.addRowForm.removeControl('workOrderNumber');
			this.addRowForm.removeControl('workOrderDesc');

			if (this.addRowForm.value.type && this.addRowForm.value.type.code === TimesheetEntryType.OVERTIME) {
				this.addRowForm.addControl('natureOfWorkOT', new UntypedFormControl('', Validators.required));
			}
		}
	}

	setContentCustomStyles() {
		const interval = setInterval(() => {
			if (document.querySelector('.timesheet') && document.querySelector('.calendarDisplay')) {
				clearInterval(interval);

				const windowHeight = window.innerHeight;
				const headerHeight = (document.querySelector('app-header') as HTMLElement).offsetHeight || 0;
				const headerBorderHeight = 2;

				// reset the height before applying any resize changes as not resetting it will cause the scroll height to continously get bigger each resize
				(document.querySelector('.timesheet') as HTMLElement).style.height = `${windowHeight - headerHeight - headerBorderHeight}px`;
				(document.querySelector('.timesheet') as HTMLElement).style.height = `${
					document.body.scrollHeight - headerHeight - headerBorderHeight
				}px`;

				/* 
          - the timesheet height is the height of the right hand side of the timesheet component page
          - the calendarChangeBtns are the heights of the buttons used to change the month displayed on the left hand side panel
          - the buttonAdditionalPadding is the additional padding added to the buttons to keep 1px gap for both buttons between 
            the calendars that get displayed in the center of the left panel
        */
				const calendarChangeBtns = (document.querySelector('.buttonContainer.top') as HTMLElement).offsetHeight || 0;
				const buttonAdditionalPadding = 1;

				// set the height of the middle section of the left hand side panel that displays the two calendars
				(document.querySelector('.calendarDisplay') as HTMLElement).style.height = `calc(100% - ${
					calendarChangeBtns - buttonAdditionalPadding
				}px)`;
			} else {
				if (this.isEditingEmployeeTimesheet) {
					clearInterval(interval);
				}
			}
		}, 250);
	}

	ngOnInit(): void {
		if (!this.isEditingEmployeeTimesheet) {
			this.store.dispatch(GetAllTimesheets());
		}

		this.selectedYear$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((selectedYear) => (this.selectedYear = selectedYear));
		this.payPeriods$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((payPeriods) => (this.payPeriods = payPeriods));
		this.hasSubmittedTimesheet$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((hasSubmittedTimesheet) => {
			this.hasSubmittedTimesheet = hasSubmittedTimesheet;
			this.toggleEdit = hasSubmittedTimesheet;
		});

		this.profile$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((profile) => {
			this.profile = profile;
			if (this.isEditingEmployeeTimesheet) {
				const currentEmployeeProfile =
					profile.manage?.find((teamMember) => HelperFunctions.compareEmail(teamMember.user.email, this.currentEmployeeEmail)) ||
					profile.delegated?.find((teamMember) => HelperFunctions.compareEmail(teamMember.user.email, this.currentEmployeeEmail)) ||
					profile.managedGoneFromDNV?.find((teamMember) => HelperFunctions.compareEmail(teamMember.user.email, this.currentEmployeeEmail));

				// this.currentConfiguration = currentEmployeeProfile?.configurations
				// 	? HelperFunctions.getCurrentConfiguration(currentEmployeeProfile?.configurations)
				// 	: blankConfiguration;

				this.employeeConfigurations = currentEmployeeProfile?.configurations || [];
				this.userScheduledActings = currentEmployeeProfile?.scheduledActings || [];

				this.editEmp = true;
				this.empNum = currentEmployeeProfile?.user.employeeNumber;
				this.empName = currentEmployeeProfile?.user.firstName + ' ' + currentEmployeeProfile?.user.lastName;
			} else {
				if (profile.configuration.length > 0) {
					// this.currentConfiguration = HelperFunctions.getCurrentConfiguration(profile.configuration); // date // TODO need to provide timesheet date
					this.employeeConfigurations = profile.configuration;
					this.userScheduledActings = profile.scheduledActings;
				}
			}
			this.applyOptionFilters();
		});

		this.route.paramMap.subscribe((params) => {
			const date = params.get('timesheetDate');
			const yr = Number(date?.substring(0, 4));
			const mon = Number(date?.substring(4, 6));
			const day = Number(date?.substring(6, 8));
			// set selectedtimesheet and currentconfiguration, also need to populate calendar data (allCalendarTimesheets)??
			if (date) {
				this.dateFrRoute = new Date(yr, mon - 1, day, 0, 0, 0, 0);
			}
		});

		if (this.isEditingEmployeeTimesheet) {
			this.employeeTimesheets$?.pipe(takeUntil(this.ngUnsubscribe)).subscribe((employeeSubmissions) => {
				const currentEmployeeTimesheets =
					employeeSubmissions.find((submission) => submission.employeeEmail == this.currentEmployeeEmail)?.timesheets || [];
				this.timesheets = currentEmployeeTimesheets;
				this.allCalendarTimesheets = [];

				currentEmployeeTimesheets.forEach((timesheet) =>
					HelperFunctions.getAllTimesheetYearsAndPaydates(timesheet, this.yearsDataProvided, this.payDates),
				);
				HelperFunctions.convertTimesheetToCalendarFriendlyObj(currentEmployeeTimesheets, this.yearsDataProvided, this.allCalendarTimesheets);

				if (this.selectedTimesheet) {
					const timesheet =
						this.timesheets.find((timesheet) => timesheet.startDate.toString() === this.selectedTimesheet!.startDate.toString()) ||
						this.selectedTimesheet;

					this.handleWeekSelected(timesheet, this.isCalendarOneSelected);
					if (!this.hasCalendarHadInitialLoad) this.setCalendarMonths();
				}
			});
		} else {
			this.timesheets$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((timesheets) => {
				this.timesheets = timesheets;
				this.allCalendarTimesheets = [];

				timesheets.forEach((timesheet) => HelperFunctions.getAllTimesheetYearsAndPaydates(timesheet, this.yearsDataProvided, this.payDates));
				HelperFunctions.convertTimesheetToCalendarFriendlyObj(timesheets, this.yearsDataProvided, this.allCalendarTimesheets);

				if (this.selectedTimesheet) {
					const timesheet =
						this.timesheets.find((timesheet) => timesheet.startDate.toString() === this.selectedTimesheet!.startDate.toString()) ||
						this.selectedTimesheet;

					this.handleWeekSelected(timesheet, this.isCalendarOneSelected);
				}
				if (this.dateFrRoute) {
					this.selectedTimesheet =
						this.timesheets.find((timesheet) => timesheet.startDate.toString() === this.dateFrRoute?.toString()) ||
						this.selectedTimesheet;

					if (this.selectedTimesheet) this.handleWeekSelected(this.selectedTimesheet, this.isCalendarOneSelected);
					if (!this.hasCalendarHadInitialLoad) this.setCalendarMonths();
				}
			});
		}

		this.timesheetHistory$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((timesheetHistory) => {
			this.timesheetHistory = timesheetHistory;
		});

		this.userImages$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((userImages) => {
			this.userImages = userImages;
		});

		this.exceptionTypes$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((e) => {
			this.exceptionTypes = e;
		});

		this.exceptionTypes$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((e) => {
			this.exceptionTypes = e;
		});

		this.payPeriodEntries$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((ppe) => {
			this.payPeriodEntries = ppe;
		});
	}

	getMemberProfile(upn: string): SafeUrl | null {
		return this.userImages[upn] || null;
	}

	ngOnDestroy() {
		this.ngUnsubscribe.next();
		this.ngUnsubscribe.complete();
	}

	ngAfterContentChecked(): void {
		this.changeDetector.detectChanges();
	}

	removeAddedFormControls() {
		this.currentType = '';

		// remove all special fields from the last selection
		if (this.addRowForm.contains('bankOrPayoutOT') || this.addRowForm.contains('continuousOT')) {
			['prescheduledOT', 'adjacentOT', 'bankOrPayoutOT', 'natureOfWorkOT'].forEach((name) => this.addRowForm.removeControl(name));
		}

		if (this.addRowForm.contains('sickType')) {
			this.addRowForm.removeControl('sickType');
		}

		if (this.addRowForm.contains('leaveType')) {
			this.addRowForm.removeControl('leaveType');
		}

		if (this.addRowForm.contains('bankedType')) {
			this.addRowForm.removeControl('bankedType');
		}

		if (this.addRowForm.contains('unionBusinessType')) {
			this.addRowForm.removeControl('unionBusinessType');
		}
	}

	addRequiredFormControls(exceptionTypeName: string) {
		switch (exceptionTypeName) {
			case TimesheetEntryType.OVERTIME:
				['prescheduledOT', 'adjacentOT', 'bankOrPayoutOT', 'natureOfWorkOT'].forEach((name) => {
					this.addRowForm.addControl(name, new UntypedFormControl(null, Validators.required));
				});
				break;

			case TimesheetEntryType.SICK:
				this.addRowForm.addControl('sickType', new UntypedFormControl(null, Validators.required));
				break;

			case TimesheetEntryType.OTHER:
				this.addRowForm.addControl('leaveType', new UntypedFormControl(null, Validators.required));
				break;

			case TimesheetEntryType.BANKED:
				this.addRowForm.addControl('bankedType', new UntypedFormControl(null, Validators.required));
				break;

			case TimesheetEntryType.UNION:
				this.addRowForm.addControl('unionBusinessType', new UntypedFormControl(null, Validators.required));
				break;

			default:
				break;
		}
	}

	applyToRowForm(editFormChanges: EditTimesheetFormChanges) {
		// read from HelperFunctions.getTimesheetExceptionTypes because the entry might now be inactive
		const type = HelperFunctions.getTimesheetExceptionTypes().find((type) => type.code === editFormChanges.previousEntry.name);
		const options = editFormChanges.previousEntry.metadata.options || {};
		const comments = editFormChanges.previousEntry.metadata.comments || '';

		this.addRowForm.controls.type.setValue(type);
		this.addRowForm.controls.comments.setValue(comments);

		const workOrderNumber = editFormChanges.previousEntry.metadata.options?.workOrderNumber || '';
		this.addRowForm.controls.isWorkOrderTime.setValue(workOrderNumber.length > 0);
		this.updateWorkOrderControls();

		if (Object.keys(options).length) {
			for (const prop in options) {
				if (this.addRowForm.controls.hasOwnProperty(prop)) {
					this.addRowForm.controls[prop].setValue(options[prop]);
				}

				if (this.addRowForm.contains('workOrderNumber')) {
					this.addRowForm.controls.workOrderNumber.setValue(workOrderNumber.slice(1, workOrderNumber.length - 1));
				}
			}
		}
	}

	extractMonthlyData(monthToExtract: number, yearToExtract: number): CalendarMonthlyTimesheets {
		return (
			this.allCalendarTimesheets.find(
				(calendarTimesheet) => calendarTimesheet.month === monthToExtract && calendarTimesheet.year === yearToExtract,
			) || {
				year: this.selectedYear,
				month: new Date().getMonth(),
				timesheets: [],
				payDates: [],
			}
		);
	}

	getHasPreviousMonthEntry() {
		let month = this.calendarOneMonth - 1;
		let year = this.calendarOneYear;

		if (month === -1) {
			month = 11;
			year--;
		}

		return HelperFunctions.getTimesheetDataExistsForDate(year, month, this.timesheets);
	}

	getHasNextMonthEntry() {
		let month = this.calendarTwoMonth + 1;
		let year = this.calendarTwoYear;

		if (month === 12) {
			month = 0;
			year++;
		}

		return HelperFunctions.getTimesheetDataExistsForDate(year, month, this.timesheets);
	}

	loadPreviousMonth() {
		if (!this.getHasPreviousMonthEntry()) {
			return;
		}

		if (this.calendarOneMonth === 0) {
			this.calendarOneMonth = 11;
			this.calendarOneYear--;
		} else {
			this.calendarOneMonth--;
		}

		if (this.calendarTwoMonth === 0) {
			this.calendarTwoMonth = 11;
			this.calendarTwoYear--;
		} else {
			this.calendarTwoMonth--;
		}
	}

	loadNextMonth() {
		if (!this.getHasNextMonthEntry()) {
			return;
		}

		if (this.calendarOneMonth === 11) {
			this.calendarOneMonth = 0;
			this.calendarOneYear++;
		} else {
			this.calendarOneMonth++;
		}

		if (this.calendarTwoMonth === 11) {
			this.calendarTwoMonth = 0;
			this.calendarTwoYear++;
		} else {
			this.calendarTwoMonth++;
		}
	}

	openDateSelectionPanel = () => (this.toggleCdoDateSelectionPanel = true);
	closeDateSelectionPanel = () => (this.toggleCdoDateSelectionPanel = false);

	getFormattedCdoReassignmentDate() {
		return `${(this.selectedCdoReassignmentDate!.getMonth() + 1).toString().padStart(2, '0')}/${this.selectedCdoReassignmentDate!.getDate().toString().padStart(2, '0')}/${this.selectedCdoReassignmentDate!.getFullYear()}`;
	}

	getDaysFromPayPeriodStart = (weekIdx: number, dayIdx: number) => 7 * weekIdx + dayIdx;

	getCdoCalendarCurrentDate = (daysFromStart: number) => {
		let date = HelperFunctions.getFutureDate(new Date(this.timesheetPayperiod.startDate), daysFromStart);
		return date;
	};

	getCdoCalendarDateDisplayed = (weekIdx: number, dayIdx: number) => {
		return this.getCdoCalendarCurrentDate(this.getDaysFromPayPeriodStart(weekIdx, dayIdx)).getDate();
	};

	getCalendarBarStyles = (currentWeek: number, currentDay: number) => {
		let timesheet = this.getPayPeriodWeekTimesheet(currentWeek);
		return HelperFunctions.getCalendarBarStyles(timesheet, currentDay);
	};

	getPayPeriodWeekTimesheet = (currentWeek: number) => {
		let timesheet = this.selectedPayPeriodTimesheets[0];
		if (currentWeek === 1) timesheet = this.selectedPayPeriodTimesheets[1];
		return timesheet;
	};

	getIsSavedOrPredictedData(currentWeek: number) {
		let timesheet = this.getPayPeriodWeekTimesheet(currentWeek);
		return timesheet.status === TimesheetStatus.Predicted || timesheet.status === TimesheetStatus.Saved;
	}

	getIsSelectedCdoRescheduleDate(daysFromStart: number) {
		if (!this.selectedCdoReassignmentDate) return false;
		let currentPayPeriodDate = this.getCdoCalendarCurrentDate(daysFromStart);
		return (
			this.selectedCdoReassignmentDate.getMonth() === currentPayPeriodDate.getMonth() &&
			this.selectedCdoReassignmentDate.getDate() === currentPayPeriodDate.getDate() &&
			this.selectedCdoReassignmentDate.getFullYear() === currentPayPeriodDate.getFullYear()
		);
	}

	getWeekSelectionIsDisabled(currentWeek: number) {
		let timesheetIsFirstWeek = HelperFunctions.getTimesheetPayPeriodInfo(this.selectedTimesheet!, this.payPeriods).includes('Week 1');

		if (timesheetIsFirstWeek && currentWeek === 0) return true;
		if (timesheetIsFirstWeek && currentWeek === 1) return false;
		if (!timesheetIsFirstWeek && currentWeek === 0) return false;
		return true;
	}

	getCdoCalendarMonthAndYear() {
		let startMonthYear = HelperFunctions.getCdoCalendarDate(new Date(this.timesheetPayperiod.startDate));
		let endMonthYear = HelperFunctions.getCdoCalendarDate(new Date(this.timesheetPayperiod.endDate));

		if (startMonthYear === endMonthYear) return startMonthYear;
		return `${HelperFunctions.getMonthNameFromDate(new Date(this.timesheetPayperiod.startDate))} - ${endMonthYear}`;
	}

	setCdoRescheduleDate(currentWeek: number, currentDay: number) {
		if (this.getWeekSelectionIsDisabled(currentWeek)) return;
		let cdoDate = this.getCdoCalendarCurrentDate(this.getDaysFromPayPeriodStart(currentWeek, currentDay));
		this.selectedCdoReassignmentDate = cdoDate;
		this.closeDateSelectionPanel();
	}

	handleWeekSelected(selectedTimesheet: Timesheet, isCalendarOne: boolean) {
		this.timesheetPayperiod = this.payPeriods.find((pp) =>
			HelperFunctions.getDateIsWithinBounds(new Date(pp.startDate), new Date(pp.endDate), new Date(selectedTimesheet.startDate)),
		)!;

		let payPeriodStartDate = new Date(this.timesheetPayperiod.startDate);
		this.ngbStartDate = new NgbDate(payPeriodStartDate.getFullYear(), payPeriodStartDate.getMonth() + 1, payPeriodStartDate.getDate());

		this.isCalendarOneSelected = isCalendarOne;
		this.selectedTimesheet = selectedTimesheet;
		this.selectedPayPeriodTimesheets = this.timesheets.filter((timesheet) => timesheet.payPeriod === this.selectedTimesheet?.payPeriod);
		this.currentConfiguration = HelperFunctions.configurationOn(this.employeeConfigurations, new Date(selectedTimesheet.startDate));
		this.applyOptionFilters();
		this.weekOneTsHasUsedCdo = false;

		// Check if week1 has a cdo on in it in the event that the week2 cdo was shifted back a week
		let selectedTimesheetIndex = this.selectedPayPeriodTimesheets.findIndex((ts) => ts === selectedTimesheet);
		if (selectedTimesheetIndex === 1) {
			let weekOneTs = this.selectedPayPeriodTimesheets[0];
			let isWeekOneSubmitted = weekOneTs.status !== 'Predicted' && weekOneTs.status !== 'Saved';
			let weekOneHasCdoUsed = weekOneTs.entries.some(
				(entry) => entry.name === TimesheetEntryType.CDO && entry.durations.some((duration) => duration > 0),
			);

			this.weekOneTsHasUsedCdo = isWeekOneSubmitted && weekOneHasCdoUsed;

			// this.bankCDOForm.get('cdoUsageType')?.setValue('banked');
			// this.bankCDOForm.get('cdoUsageType')?.disable();
			// } else {
			// this.bankCDOForm.get('cdoUsageType')?.setValue('payPeriod');
			// this.bankCDOForm.get('cdoUsageType')?.enable();
		}

		this.hasSubmittedTimesheet$.next(
			this.selectedTimesheet.status !== TimesheetStatus.Predicted && this.selectedTimesheet.status !== TimesheetStatus.Saved,
		);

		if (!this.isEditingEmployeeTimesheet) {
			const startDate = new Date(selectedTimesheet.startDate);
			const year = startDate.getFullYear();
			const month = HelperFunctions.convertSingleConstToDoubleDigitStr(startDate.getMonth() + 1);
			const date = HelperFunctions.convertSingleConstToDoubleDigitStr(startDate.getDate());

			const timesheetURLDate = `${year}${month}${date}`;
			const timesheetURL = `/timesheet;timesheetDate=${timesheetURLDate}`;
			this.location.replaceState(timesheetURL);
			this.dateFrRoute = new Date(year, Number(month) - 1, Number(date), 0, 0, 0, 0);
		}

		this.selectedWeekScheduledActing = this.userScheduledActings.find((sa) => {
			let isActing = false;
			for (let i = 0; i < 7; i++) {
				let dateCmp = HelperFunctions.getFutureDate(this.selectedTimesheet!.startDate, i);
				isActing = HelperFunctions.getDateIsWithinBounds(new Date(sa.from), new Date(sa.to), dateCmp);
				if (isActing) break;
			}

			return isActing;
		});
	}

	generateWeekRangeString(timesheet: Timesheet | null, includeYear = false): string {
		this.payperiodWeek = HelperFunctions.getTimesheetPayPeriodInfo(timesheet!, this.payPeriods);
		return HelperFunctions.generateWeekRangeString(timesheet, includeYear);
	}

	historyTime(date: Date | undefined) {
		if (date) {
			return HelperFunctions.getFullMonthAndDayFromDate(date) + ' at ' + HelperFunctions.get12HourTimeFromDate(date);
		} else {
			return 'Date and Time Missing';
		}
	}

	applyActingMetadataIfApplicable(timesheet: PostTimesheet): PostTimesheet {
		const entryData: TimesheetEntry2[] = JSON.parse(timesheet.entryData);
		if (!entryData.some(e => e.name === TimesheetEntryType.ACTING)) {
			return timesheet;
		}

		const entryDataIndex = entryData.findIndex(e => e.name === TimesheetEntryType.ACTING);
		const metadata = entryData[entryDataIndex].metadata;

		if (this.getRowCanChargeToWorkOrder(TimesheetEntryType.ACTING)) {
			let formattedValue = "";
			let workOrderDesc = "";

			if (this.addRowForm.value.workOrderNumber) {
				formattedValue = `\\${this.addRowForm.value.workOrderNumber.replaceAll("\\", "").replaceAll(".", "")}.`
				workOrderDesc = this.addRowForm.value.workOrderDesc || '';
			}

			metadata.options = {
				workOrderNumber: formattedValue,
				workOrderDesc: workOrderDesc,
			};
		}

		if (this.selectedWeekScheduledActing) {
			metadata.description = `${this.selectedWeekScheduledActing.description}`;
			metadata.jobStep = this.selectedWeekScheduledActing.jobStep;
			metadata.jobType = this.selectedWeekScheduledActing.jobType;
			metadata.rate = this.selectedWeekScheduledActing.rate;
			metadata.fromDate = this.selectedWeekScheduledActing.from;
			metadata.toDate = this.selectedWeekScheduledActing.to;
			metadata.isActing = true;
			metadata.showActingWarning = false;

			if (metadata.needsActingResubmit) {
				delete metadata.needsActingResubmit;
			}
		} else {
			metadata.showActingWarning = true;
		}
		
		if (metadata.options.workOrderNumber && metadata.options.workOrderNumber.length > 0) {
			metadata.description = `[WO No: ${metadata.options.workOrderNumber.slice(1, metadata.options.workOrderNumber.length - 1)}]`;
			metadata.description += ` - ${metadata.options.workOrderDesc}`;
			metadata.comments = metadata.options.workOrderDesc;
		} else {
			if (metadata.comments) {
				metadata.description = metadata.description + ' (' + metadata.comments + ')';
			}
		}

		// const entryDataIndexOvertime = entryData.findIndex(e => e.name === TimesheetEntryType.OVERTIME);
		// if (entryDataIndexOvertime >= 0 && scheduledActing) {
		// 	const metadataOvertime = entryData[entryDataIndexOvertime].metadata;
		// 	metadataOvertime.jobStep = scheduledActing.jobStep;
		// 	metadataOvertime.jobType = scheduledActing.jobType;
		// 	entryData[entryDataIndexOvertime].metadata = metadataOvertime;
		// }

		entryData[entryDataIndex].metadata = metadata;
		timesheet.entryData = JSON.stringify(entryData);
		return timesheet;
	}

	gatherMetadata(): { [id: string]: any } {
		const metadata: { [id: string]: any } = {
			comments: this.addRowForm.value.comments || '',
			options: {},
			description: '',
		};

		if (this.getRowCanChargeToWorkOrder(this.currentType)) {
			let formattedValue = "";
			let workOrderDesc = "";

			if (this.addRowForm.value.workOrderNumber) {
				formattedValue = `\\${this.addRowForm.value.workOrderNumber.replaceAll("\\", "").replaceAll(".", "")}.`
				workOrderDesc = this.addRowForm.value.workOrderDesc || '';
			}

			metadata.options = {
				workOrderNumber: formattedValue,
				workOrderDesc: workOrderDesc,
			};
		}

		switch (this.currentType) {
			case TimesheetEntryType.OVERTIME:
				this.addRowForm.get('adjacentOT')?.enable();

				metadata.options = {
					...metadata.options,
					prescheduledOT: this.addRowForm.value.prescheduledOT,
					adjacentOT: this.addRowForm.value.adjacentOT,
					bankOrPayoutOT: this.addRowForm.value.bankOrPayoutOT,
					natureOfWorkOT: this.addRowForm.value.natureOfWorkOT || ''
				};

				// if (scheduledActing) {
				// 	metadata.jobStep = scheduledActing.jobStep;
				// 	metadata.jobType = scheduledActing.jobType;
				// 	metadata.rate = scheduledActing.rate;
				// }

				metadata.description =
					(this.addRowForm.value.prescheduledOT === OverTimePrescheduledOptions.PrescheduledOTyes ? 'Prescheduled' : 'Unscheduled') +
					', ' +
					this.optionDisplayLookup[this.addRowForm.value.adjacentOT] +
					' - ' +
					(this.addRowForm.value.bankOrPayoutOT === BankOrPayoutOptionsCode.BankIt ? 'Banked' : 'Paid out') +
					' (' +
					this.addRowForm.value.natureOfWorkOT +
					')';
				break;

			case TimesheetEntryType.COUNCIL:
				metadata.description = 'Banked';
				break;

			case TimesheetEntryType.SICK:
				metadata.options = {
					...metadata.options,
					sickType: this.addRowForm.value.sickType,
				};
				metadata.description = this.optionDisplayLookup[this.addRowForm.value.sickType];
				break;

			case TimesheetEntryType.OTHER:
				metadata.options = {
					...metadata.options,
					leaveType: this.addRowForm.value.leaveType,
				};
				metadata.description = this.optionDisplayLookup[this.addRowForm.value.leaveType];
				break;

			case TimesheetEntryType.BANKED:
				metadata.options = {
					...metadata.options,
					bankedType: this.addRowForm.value.bankedType,
				};
				metadata.description = this.optionDisplayLookup[this.addRowForm.value.bankedType];
				break;

			case TimesheetEntryType.UNION:
				metadata.options = {
					...metadata.options,
					unionBusinessType: this.addRowForm.value.unionBusinessType,
				};
				metadata.description = this.optionDisplayLookup[this.addRowForm.value.unionBusinessType];
				break;

			case TimesheetEntryType.ACTING:
				if (this.selectedWeekScheduledActing) {
					metadata.description = `${this.selectedWeekScheduledActing.description}`;
					metadata.jobStep = this.selectedWeekScheduledActing.jobStep;
					metadata.jobType = this.selectedWeekScheduledActing.jobType;
					metadata.rate = this.selectedWeekScheduledActing.rate;
					metadata.fromDate = this.selectedWeekScheduledActing.from;
					metadata.toDate = this.selectedWeekScheduledActing.to;
					metadata.isActing = true;
					metadata.showActingWarning = false;
				} else {
					metadata.showActingWarning = true;
				}
				break;

			default:
				break;
		}

		if (metadata.options.workOrderNumber && metadata.options.workOrderNumber.length > 0) {
			metadata.description = `[WO No: ${metadata.options.workOrderNumber.slice(1, metadata.options.workOrderNumber.length - 1)}]`;
			metadata.description += ` - ${metadata.options.workOrderDesc}`;
			metadata.comments = metadata.options.workOrderDesc;
		} else {
			if (metadata.comments) {
				metadata.description = metadata.description + ' (' + metadata.comments + ')';
			}
		}

		return metadata;
	}

	editRow() {
		if (this.addRowForm.valid) {
			if (this.addRowForm?.value?.prescheduledOT === OverTimePrescheduledOptions.PrescheduledOTno) {
				this.addRowForm.patchValue({ adjacentOT: OverTimeContextOptions.ScheduledNonAdjacent });
			}

			const previousEntry = this.editTimesheetFormChanges.previousEntry;

			const newTimeEntry: TimesheetEntry2 = Object.assign({}, previousEntry, {
				name: this.addRowForm.value.type.code,
				metadata: this.gatherMetadata(),
			});

			// need to handle the hours
			// if (newTimeEntry.name === TimesheetEntryType.ACTING && newTimeEntry.metadata.isActing) {
			// 	for (let i = 0; i < 7; i++) {
			// 		var dayMetadata = this.selectedTimesheet!.metadata[i];
			// 		var isActingDate = HelperFunctions.getDateIsWithinBounds(
			// 			newTimeEntry.metadata.fromDate,
			// 			newTimeEntry.metadata.toDate,
			// 			HelperFunctions.getFutureDate(this.selectedTimesheet!.startDate, i)
			// 		);

			// 		// if (isActingDate && !dayMetadata.isCDO && !dayMetadata.isStat) {
			// 		if (isActingDate) {
			// 			newTimeEntry.durations[i] = dayMetadata.expectedDailyHours;
			// 		}
			// 	}
			// }

			this.newEditFormChanges = {
				previousEntry: previousEntry,
				newEntry: newTimeEntry,
				timeEntryIndexToReplace: this.editTimesheetFormChanges.timeEntryIndexToReplace,
			};

			this.close();
		}
	}

	addRow() {
		if (this.addRowForm.valid) {
			if (this.addRowForm?.value?.prescheduledOT === OverTimePrescheduledOptions.PrescheduledOTno) {
				this.addRowForm.patchValue({ adjacentOT: OverTimeContextOptions.ScheduledNonAdjacent });
			}

			const durations = Array(7).fill(0);
			const addedRow: TimesheetEntry2 = {
				name: this.currentType,
				metadata: this.gatherMetadata(),
				durations,
			};

			// need to handle the automatic row filling
			// if (addedRow.name === TimesheetEntryType.ACTING && addedRow.metadata.isActing) {
			// 	for (let i = 0; i < 7; i++) {
			// 		var dayMetadata = this.selectedTimesheet!.metadata[i];
			// 		var isActingDate = HelperFunctions.getDateIsWithinBounds(
			// 			addedRow.metadata.fromDate,
			// 			addedRow.metadata.toDate,
			// 			HelperFunctions.getFutureDate(this.selectedTimesheet!.startDate, i)
			// 		);

			// 		// if (isActingDate && !dayMetadata.isCDO && !dayMetadata.isStat) {
			// 		if (isActingDate) {
			// 			addedRow.durations[i] = dayMetadata.expectedDailyHours;
			// 		}
			// 	}
			// }

			this.addedRows = [addedRow];
			this.close();
		}
	}

	getRowCanChargeToWorkOrder(currentType: string) {
		let isChargable = false;
		let matchingRecord = this.workOrderChargeAbleEntries.find(entry => entry.entryType === currentType);
		if (matchingRecord) isChargable = matchingRecord.workOrderChargeable;
		return isChargable;
	}

	bankCDOFormSubmit() {
		if (this.bankCDOForm.valid || this.bankCDOForm.value.cdoUsageType === 'payPeriod') {
			this.closeBankCDOModal(true);
		}
	}

	closeBankCDOModal(shouldFireSubmit: boolean) {
		this.bankCDOModalRef.close(shouldFireSubmit);
		if (!shouldFireSubmit) {
			this.bankCDOForm.reset();
		}
	}

	resetSidebarOnTypeChange(event: TimesheetExceptionType) {
		const comments = this.addRowForm.controls.comments.value;
		this.addRowForm.reset();
		this.addRowForm.controls.type.setValue(event);
		this.addRowForm.controls.comments.setValue(comments);

		if (event.code === TimesheetEntryType.OVERTIME) {
			const prescheduledOT = this.addRowForm?.value?.prescheduledOT;
			if (!prescheduledOT) {
				this.addRowForm.patchValue({ prescheduledOT: OverTimePrescheduledOptions.PrescheduledOTyes });
				this.addRowForm.patchValue({ adjacentOT: OverTimeContextOptions.ScheduleAdjacent });
				this.addRowForm.patchValue({ bankOrPayoutOT: BankOrPayoutOptionsCode.PayOut });
			}
		}
	}

	setCDOBankInformation(timesheet: PostTimesheet, checkNeedsBankingApplied: boolean = false) {
		if (!this.currentConfiguration.cdo) return;

		const timesheetMetadata: TimesheetMetadata[] = JSON.parse(timesheet.timesheetMetadata);
		const entryData: TimesheetEntry2[] = JSON.parse(timesheet.entryData);
		let needsBanking = false;

		if (checkNeedsBankingApplied) {
			if (
				this.weekOneTsHasUsedCdo &&
				timesheetMetadata.some((metadata) => metadata.isCDO) &&
				!entryData.some(
					(entry) =>
						entry.name === TimesheetEntryType.CDO && entry.durations.some((d) => d === this.currentConfiguration.durationOfRegularDay),
				)
			) {
				needsBanking = true;
			}

			if (!needsBanking) {
				return;
			}
		}

		// -1 to bring [1-7] => [0-6] and -8 to bring [8-14] => [0-6]
		var cdoDayIndex = this.currentConfiguration.cdoDay <= 7 ? this.currentConfiguration.cdoDay - 1 : this.currentConfiguration.cdoDay - 8;
		if (!timesheetMetadata[cdoDayIndex - 1].isCDO && timesheetMetadata.find((tm) => tm.isCDO)?.isShiftedCDO) {
			cdoDayIndex = timesheetMetadata.findIndex((tm) => tm.isCDO);
		}

		const cdoDate = HelperFunctions.getFutureDate(this.selectedTimesheet!.startDate, cdoDayIndex);
		const cdoMonthName = HelperFunctions.getMonthName(cdoDate.getFullYear(), cdoDate.getMonth());

		const cdoDateDescription = `${HelperFunctions.convertNumberToDayOfWeek(cdoDate.getDay())} ${cdoMonthName} ${cdoDate.getDate()}`;
		let reason = '';
		let movedCdoDate = '';
		let bankType: CDOBankingOptions = this.bankCDOForm.value.bankType;

		if (checkNeedsBankingApplied && needsBanking) {
			reason = this.cdoBankOptions.find((bankOption) => bankOption.code === CDOBankingOptions.PreviousWeek)!.entryText;
			bankType = CDOBankingOptions.PreviousWeek;
		} else {
			if (this.bankCDOForm.value.cdoUsageType === 'payPeriod') {
				bankType = this.getWeekSelectionIsDisabled(0) ? CDOBankingOptions.NextWeek : CDOBankingOptions.PreviousWeek;
				reason = this.cdoBankOptions.find((bankOption) => bankOption.code === bankType)?.entryText || 'Unknown';
				reason += ` on ${HelperFunctions.getDateString(this.selectedCdoReassignmentDate!, false)}`;
				movedCdoDate = HelperFunctions.getDateString(this.selectedCdoReassignmentDate!, false);
			} else {
				reason =
					this.bankCDOForm.value.bankType === CDOBankingOptions.Other
						? `Other - ${this.bankCDOForm.value.otherTypeText}`
						: this.cdoBankOptions.find((bankOption) => bankOption.code === this.bankCDOForm.value.bankType)?.entryText || 'Unknown';
			}
		}

		const bankedCDO: BankedCDOMetadata = {
			description: `CDO for ${cdoDateDescription} rescheduled. Note: ${reason}.`,
			date: cdoDate,
			options: { bankType, movedCdoDate, isShiftedCDO: timesheetMetadata.some((metadata) => metadata.isShiftedCDO) },
		};

		if (this.bankCDOForm.contains('otherTypeText')) {
			bankedCDO.options.otherTypeText = this.bankCDOForm.value.otherTypeText;
		}

		timesheetMetadata[cdoDayIndex].bankedCDO = bankedCDO;
		timesheet.timesheetMetadata = JSON.stringify(timesheetMetadata);
	}

	resetCdoDateSelectionPrompt() {
		this.closeDateSelectionPanel();
		this.selectedCdoReassignmentDate = null;
		this.bankCDOForm.get('cdoUsageType')?.setValue('payPeriod');
	}

	// handleCdoDateReassignment() {
	// 	let timesheet = this.selectedPayPeriodTimesheets[0];
	// 	if (!HelperFunctions.getDateIsWithinBounds(timesheet.startDate, timesheet.endDate, this.selectedCdoReassignmentDate!)) {
	// 		timesheet = this.selectedPayPeriodTimesheets[1];
	// 	}
	// }

	saveOrSubmitTimesheet(timesheetInfo: SaveSubmitTimesheet) {
		const ngbModalOptions: NgbModalOptions = {
			backdrop: 'static',
			keyboard: false,
			centered: true,
		};

		const startDate = timesheetInfo.startDate;
		timesheetInfo.timesheet.employeeNumber = this.empNum && this.empNum?.length > 0 ? this.empNum : this.profile.user.employeeNumber;
		var timesheet = timesheetInfo.timesheet;
		timesheet = this.applyActingMetadataIfApplicable(timesheet);

		if (timesheetInfo.isShowBankCDODialog) {
			this.bankCDOModalRef = this.modalService.open(this.content, ngbModalOptions);
			this.bankCDOModalRef.result.then((shouldFireSubmit: boolean) => {
				// if UserResponse true, then we will need to bank CDO for user.
				if (shouldFireSubmit) {
					this.setCDOBankInformation(timesheet);

					if (timesheetInfo.actionType === 'submit') {
						this.store.dispatch(
							SubmitTimesheet({
								startDate,
								timesheet,
								weekRange: HelperFunctions.generateWeekRangeString(this.selectedTimesheet!, true),
							}),
						);
					} else {
						const submitTimesheetInfo: PostTimesheet = {
							action: 'approve',
							employeeNumber: this.empNum!,
							payPeriod: timesheet.payPeriod,
							timesheetMetadata: timesheet.timesheetMetadata,
							entryData: timesheet.entryData,
						};

						this.store.dispatch(
							SubmitTimesheet({
								startDate,
								timesheet: submitTimesheetInfo,
								weekRange: HelperFunctions.generateWeekRangeString(this.selectedTimesheet!, true),
							}),
						);
					}

					// if the value is set, then we need to do the reassignment of the cdo to another day within the payperiod
					// if (this.selectedCdoReassignmentDate) {
					// 	this.handleCdoDateReassignment();
					// }

					this.activeModal.close({ employeeNumber: this.empNum, startDate: this.selectedTimesheet!.startDate });
				}

				this.bankCDOForm.reset();
				this.resetCdoDateSelectionPrompt();
			});
		} else {
			let timesheetActionTaken = "";
			if (timesheetInfo.actionType === 'save') {
				if (this.isEditingEmployeeTimesheet) {
					this.store.dispatch(
						SaveTimesheet({
							startDate,
							timesheet,
							weekRange: HelperFunctions.generateWeekRangeString(this.selectedTimesheet!, true),
							isManager: true,
						}),
					);
				} else {
					this.store.dispatch(
						SaveTimesheet({
							startDate,
							timesheet,
							weekRange: HelperFunctions.generateWeekRangeString(this.selectedTimesheet!, true),
							isManager: false,
						}),
					);
				}

				this.activeModal.close();
			} else if (timesheetInfo.actionType === 'submit') {
				timesheetActionTaken = "submitted";
				this.setCDOBankInformation(timesheet, true);
				this.store.dispatch(SubmitTimesheet({ 
					startDate, 
					timesheet, 
					weekRange: HelperFunctions.generateWeekRangeString(this.selectedTimesheet!, true) 
				}));
			} else if (timesheetInfo.actionType === 'approve') {
				timesheetActionTaken = "approved";
				this.setCDOBankInformation(timesheet, true);

				const submitTimesheetInfo: PostTimesheet = {
					action: 'approve',
					employeeNumber: this.empNum!,
					payPeriod: timesheet.payPeriod,
					timesheetMetadata: timesheet.timesheetMetadata,
					entryData: timesheet.entryData,
				};

				const approveTimesheetInfo: TimesheetApprovalSubmission[] = [
					{
						employeeNumber: this.empNum!,
						timesheetStartDates: [this.selectedTimesheet!.startDate],
						isEdit: timesheetInfo.isEdited,
						isApprovingFromEditModal: true,
					},
				];

				this.store.dispatch(
					UpdateTimesheetApproval({
						startDate,
						timesheet: submitTimesheetInfo,
						weekRange: HelperFunctions.generateWeekRangeString(this.selectedTimesheet!, true),
						approveTimesheetInfo,
						isEdited: timesheetInfo.isEdited,
					}),
				);
			}

			this.activeModal.close({ 
				employeeNumber: this.empNum, 
				startDate: this.selectedTimesheet!.startDate, 
				actionTaken: timesheetActionTaken
			});
		}
	}

	hasSubmittedTimesheetData(hasSubmittedTimesheet: boolean) {
		// this.hasSubmittedTimesheet = hasSubmittedTimesheet;
		// this.toggleEdit = hasSubmittedTimesheet; // Is commenting this line here causing any issue?
		// now setting toggleEdit in ngOnInit
	}

	editOverride(toggle: boolean) {
		this.toggleEdit = toggle;
	}

	open(content: any) {
		this.closeAnyOffCanvas();
		this.updateWorkOrderControls();
		this.offcanvasService.open(content, {
			ariaLabelledBy: 'offcanvas-basic-title',
			position: 'end',
			container: 'app-timesheet',
		});
	}

	openEdit(editTimesheetFormChanges: EditTimesheetFormChanges, content: any) {
		this.isEdit = true;
		this.editTimesheetFormChanges = editTimesheetFormChanges;

		this.applyToRowForm(editTimesheetFormChanges);
		this.checkCallout();
		this.open(content);
	}

	close() {
		this.closeAnyOffCanvas();
		setTimeout(() => this.addRowForm.reset(), 500);
		this.isEdit = false;
		this.removeAddedFormControls();
	}

	openHistoryPanel(content: any) {
		this.closeAnyOffCanvas();
		this.offcanvasService.open(content, { ariaLabelledBy: 'offcanvas-basic-title', position: 'end' });
	}

	closeAnyOffCanvas() {
		if (this.offcanvasService.hasOpenOffcanvas()) {
			this.offcanvasService.dismiss();
		}
	}

	checkCallout(event: any = null) {
		if (this.addRowForm?.value?.prescheduledOT === OverTimePrescheduledOptions.PrescheduledOTno) {
			this.addRowForm.get('adjacentOT')?.disable();
			// this.addRowForm.patchValue({ 'adjacentOT': OverTimeContextOptions.ScheduledNonAdjacent });
			this.showWhenOtStartRadio = false;
		} else {
			this.addRowForm.get('adjacentOT')?.enable();
			this.showWhenOtStartRadio = true;
		}
	}

	viewHistory(): void {
		this.selectedHistoryTS.clear();
		const startDate = HelperFunctions.convertToYYYYMMDD(this.selectedTimesheet!.startDate);
		// const employeeNumber = this.profile.user.employeeNumber;
		const employeeNumber =
			this.currentEmployeeEmail === null
				? this.profile.user.employeeNumber
				: [...this.profile.manage.map((employee) => employee.user), ...this.profile.delegated.map((employee) => employee.user)].find(
						(employee) => employee.email === this.currentEmployeeEmail,
					)?.employeeNumber;

		this.store.dispatch(GetTimesheetHistory({ startDate, employeeNumber }));

		const ngbModalOptions: NgbModalOptions = {
			size: 'xl',
			scrollable: true,
		};

		this.timesheetHistoryModalRef = this.modalService.open(this.timesheetHistoryModal, ngbModalOptions);
	}

	closeHistoryModal() {
		this.timesheetHistoryModalRef.close();
	}

	setCalendarMonths(): void {
		if (this.selectedTimesheet && !this.hasCalendarHadInitialLoad) {
			this.hasCalendarHadInitialLoad = true;

			this.calendarOneYear = this.selectedTimesheet.endDate.getFullYear();
			this.calendarTwoYear = this.selectedTimesheet.endDate.getFullYear();
			const selectedMonth = this.selectedTimesheet.endDate.getMonth();
			if (selectedMonth !== 11) {
				this.calendarOneMonth = selectedMonth;
				this.calendarTwoMonth = selectedMonth + 1;
				this.isCalendarOneSelected = true;
			} else {
				this.calendarOneMonth = selectedMonth - 1;
				this.calendarTwoMonth = selectedMonth;
				this.isCalendarOneSelected = false;
			}
		}
	}

	toggleSection(i: number) {
		if (this.selectedHistoryTS.has(i)) {
			this.selectedHistoryTS.delete(i);
		} else {
			this.selectedHistoryTS.add(i);
		}
	}

	submittedAndEditedBy(timesheet: Timesheet, indexTimesheetHistory: number): string {
		// first iteration of the timesheet:
		// can't modify a timesheet that hasn't been submitted before and we use the last index as the data will go from newest to oldest record
		if (indexTimesheetHistory === this.timesheetHistory.length - 1) {
			return 'Timesheet submitted';
		}

		// other iterations of the timesheet:
		return 'Timesheet modified and submitted';
	}
}
